import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Ref } from 'vue-property-decorator';
import SchdulePlan from '@/modules/SchdulePlan/index.vue';
import apis from '@/apis/scheduleManage';
import DatePicker from './DatePicker.vue';

var ScheduleManage = /*#__PURE__*/function (_Vue) {
  _inherits(ScheduleManage, _Vue);

  var _super = _createSuper(ScheduleManage);

  function ScheduleManage() {
    var _this;

    _classCallCheck(this, ScheduleManage);

    _this = _super.call(this);
    _this.allSchedule = [];
    _this.loading = true;
    _this.searchStartTime = _this.$moment().format('YYYY-MM-DD 00:00:00');
    _this.searchEndTime = _this.$moment().format('YYYY-MM-DD 23:59:59');
    return _this;
  }

  _createClass(ScheduleManage, [{
    key: "dateChange",
    value: function dateChange(val) {
      this.searchStartTime = this.$moment(val).format('YYYY-MM-DD 00:00:00');
      this.searchEndTime = this.$moment(val).format('YYYY-MM-DD 23:59:59');
      this.getAllSchedule();
    }
  }, {
    key: "onReturnToday",
    value: function onReturnToday() {
      this.searchStartTime = this.$moment().format('YYYY-MM-DD 00:00:00');
      this.searchEndTime = this.$moment().format('YYYY-MM-DD 23:59:59');
      this.getAllSchedule();
      this.datePicker.reset();
    }
  }, {
    key: "getAllSchedule",
    value: function getAllSchedule() {
      var _this2 = this;

      this.loading = true;
      var params = {
        pageSize: 10000,
        pageNo: 1,
        searchDateStart: this.searchStartTime,
        searchDateEnd: this.searchEndTime
      };
      apis.allSchedule(params).then(function (res) {
        _this2.allSchedule = res.data.list || [];
        _this2.loading = false;
      }).catch(function (_) {
        _this2.loading = false;
      });
    }
  }, {
    key: "created",
    value: function created() {
      this.getAllSchedule();
    }
  }, {
    key: "isShowToday",
    get: function get() {
      return this.$moment(this.searchStartTime).format('YYYY-MM-DD') !== this.$moment().format('YYYY-MM-DD');
    }
  }]);

  return ScheduleManage;
}(Vue);

__decorate([Ref('datePicker')], ScheduleManage.prototype, "datePicker", void 0);

ScheduleManage = __decorate([Component({
  components: {
    SchdulePlan: SchdulePlan,
    DatePicker: DatePicker
  }
})], ScheduleManage);
export default ScheduleManage;